<!-- eslint-disable -->
<template lang="pug">
    .row.grade-preview
        .col-xs-10.col-xl-12.grade-preview__column
            .grade-preview__item
                svg-icon.grade-preview__icon(name="list-inverse", size="x-large")
                router-link.grade-preview__info.grade-preview__info_large.grade-preview__link.grade-preview__link_large(:to="{name: 'grade:profile', params: {id: profile.id}}")
                    | {{ profile.name }}
        .col-xs-2.col-xl-1.last-xl.grade-preview__column.end-xs(
            :class="{'is-disabled': areSchoolsBlocked || (profile.school.isActive ? !profile.school.account.status : false)}"
        )
            div
                dropdown(:icon="false" :is-last="isLast" without-move)
                    template(slot="link")
                        svg-icon.grade-preview__icon.grade-preview__icon_blue(name="select", :size="selectorSize")
                    ul.dropdown__links
                        li.dropdown__link
                            router-link.grade-preview__link(:to="{name: 'grade:profile', params: {id: profile.id}}")
                                | {{ $i18n.t('list.list_common_actionsOpen') }}
                        li.dropdown__link(v-if="isEditable")
                            router-link.grade-preview__link(:to="{name: 'grade:edit', params: {id: profile.id}}")
                                | {{ $i18n.t('list.list_common_actionsEdit') }}
                        li.dropdown__link(v-if="isShowLink")
                            a(
                                href="javascript://"
                                @click="changeStatus"
                                v-if="profile.status === 'active'"
                            )
                                | {{ $i18n.t('list.list_common_actionsArchive') }}
                            a(
                                href="javascript://"
                                @click="checkRestorePrice"
                                v-else
                            )
                                | {{ $i18n.t('list.list_common_actionsRestore') }}
                        li.dropdown__link(v-if="isShowLink")
                            a(
                                href="javascript://"
                                @click="displayConfirmDeleteModal = true"
                            )
                                | {{ $i18n.t('list.list_common_actionsDelete') }}
        .col-xl-4.grade-preview__column
            .grade-preview__item
                svg-icon.grade-preview__icon(name="profile", size="base")
                .grade-preview__info {{ amountOfStudents }}
            .grade-preview__item
                template(v-if="profile.status === 'active'")
                    svg-icon.grade-preview__icon(name="check")
                    .grade-preview__info {{ $i18n.t('common.common_status_active') }}
                template(v-else)
                    svg-icon.grade-preview__icon(name="cancel")
                    .grade-preview__info {{ $i18n.t('common.common_status_archived') }}
            .grade-preview__item
                svg-icon.grade-preview__icon(name="book")
                template(v-if="profile.course")
                    router-link.grade-preview__info.grade-preview__link(:to="{name: 'course:profile', params: {id: profile.course.id}}")
                        | {{ profile.course.name }}
                template(v-else)
                    .grade-preview__info {{ $i18n.t('list.list_grade_noCourse') }}
        .col-xl-4.grade-preview__column
            .grade-preview__item
                svg-icon.grade-preview__icon(name="university")
                template(v-if="profile.school")
                    router-link.grade-preview__info.grade-preview__link(:to="{name: 'school:profile', params: {id: profile.school.id}}")
                        | {{ profile.school.name }}
                template(v-else)
                    .grade-preview__info {{ $i18n.t('list.list_common_noSchool') }}
            .grade-preview__item
                svg-icon.grade-preview__icon(name="pin")
                .grade-preview__info(v-if="profile.location && profile.location.city && profile.location.address")
                    | {{profile.location.city}}, {{profile.location.address}}
                .grade-preview__info(v-else)
                    | {{ $i18n.t('list.list_common_noLocation') }}
            .grade-preview__item(v-if="profile.timetable" v-for="timetable in profile.timetable")
                svg-icon.grade-preview__icon(v-if="timetable.day" name="calendar")
                .grade-preview__info(v-if="timetable.day")
                    | {{ [timetable.day.toString(), "E"] | moment('dd') }}
                    | {{ timetable.time }}
            .grade-preview__item(v-else)
                .grade-preview__info
                    | {{ $i18n.t('list.list_grade_noClasses') }}
        .col-xl-3.grade-preview__column
            .grade-preview__item(v-if="profile.teachers && profile.teachers.length")
                small-user-preview(
                    :profile-type="$i18n.t('list.list_grade_teacher')"
                    :displayed-user="profile.teachers[0]"
                )
            .grade-preview__item(v-else)
                | {{ $i18n.t('list.list_grade_noTeacher') }}
        confirm-delete-modal(
            v-if="displayConfirmDeleteModal"
            @close="displayConfirmDeleteModal = false"
            @delete="$emit('delete', profile.id)"
        )
            | {{ " " + $i18n.t('list.list_grade_deleteGradeModal') }}
        cs-modal(v-if="priceModal.show" is-blur @close="closePriceModal")
            .price-modal-text(
                v-html="$i18n.t('user.user_form_withdrawal_of_money', { payment: '<b>' + priceModal.price + ' ' + $i18n.tc('olympiads.olympiads_olympiadForm_rubles', priceModal.price) + '</b>' })"
            )
            .price-modal-buttons
                cs-button(color="orange" @click="closePriceModal")
                    | {{ $i18n.t('user.user_form_cancel') }}
                cs-button(@click="changeStatus")
                    | {{ $i18n.t('user.user_form_confirm') }}
</template>

<script>
    /*eslint-disable*/
    import Dropdown from '../../../elements/Dropdown.vue';
    import GradeApi from '../../../api/grade';
    import {mapState} from 'vuex';
    import ConfirmDeleteModal from '../../../modals/ConfirmDeleteModal.vue';
    import BillingBlockMixin from '../../../utils/user/BillingBlockMixin';
    import RestoreUserMixin from '../../../utils/user/RestoreUserMixin';
    import SmallUserPreview from '../../profiles/default-elements/SmallUserPreview.vue'

    export default {
        mixins: [BillingBlockMixin, RestoreUserMixin],
        props: {
            profile: Object,
            isLast: Boolean
        },
        data() {
            return {
                displayConfirmDeleteModal: false,
                priceModal: {
                    show: false,
                    price: 0,
                },
            }
        },
        components: {
            SmallUserPreview,
            Dropdown,
            ConfirmDeleteModal
        },
        computed: {
            isEditable () {
                return this.profile.status === 'active' && (this.user.isSuperadmin || this.user.isManagerOrSupport)
                        || (this.user.type === 'admin' && this.user.schoolsIds.includes(this.profile.schoolId));
            },
            ...mapState({
                user: state => state.auth.user,
            }),
            amountOfStudents () {
                return this.profile.students.filter(student => student.status === 'active').length + ' '
                        + this.$i18n.tc('list.list_grade_studentDeclination', this.profile.students.filter(student => student.status === 'active').length);
            },
            selectorSize () {
                const windowWidth = window.innerWidth;
                return windowWidth >= 1200 ? 'xx-large' : 'x-large';
            },
            isShowLink () {
                return this.user.isSuperadmin || this.user.type === 'admin' || this.user.isManagerOrSupport;
            }
        },
        methods: {
            async checkRestorePrice() {
                if (!this.isRestoreUserAllowed('grade')) {
                    return;
                }
                const price = await GradeApi.getPriceForActivate(this.profile.id);
                this.priceModal.show = true;
                this.priceModal.price = price;
            },
            changeStatus() {
                if (this.profile.status !== 'active' && !this.isRestoreUserAllowed('grade')) {
                    return;
                }
                this.closePriceModal();
                if (this.profile.school.status === 'archived') {
                    this.$toasted.error(this.$i18n.t('errors.school_archived_cant_restore_grade'));
                } else {
                    this.profile.status === 'active' ? this.profile.status = 'archived' : this.profile.status = 'active';
                    GradeApi.update(this.profile.id, this.profile).catch(() => {
                        this.profile.status = 'archived'
                    })
                }
            },
            closePriceModal() {
                this.priceModal.show = false;
                this.priceModal.price = 0;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .grade-preview {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        padding: 16px;
    }

    .grade-preview__column {
        padding: 0;
        margin-bottom: 16px;
        @include media($xlg) {
            margin-bottom: 0;
        }
    }

    .grade-preview__column:last-child {
        margin-bottom: 0;
    }

    .grade-preview__column:first-child {
        margin-bottom: 16px;
    }

    .grade-preview__icon {
        color: $hsl-color-green-58;
    }

    .grade-preview__icon_blue {
        color: $hsl-color-blue-56;
    }

    .grade-preview__item {
        display: flex;
        align-items: center;

        font-size: 13px;
        line-height: 16px;
    }

    .grade-preview__item:not(:last-child) {
        margin-bottom: 8px;
    }

    .grade-preview__info {
        margin-left: 8px;
    }

    .grade-preview__info_large {
        margin-left: 16px;
    }

    .grade-preview__link {
        color: $hsl-color-blue-56;
        text-decoration: none;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .grade-preview__link_large {
        font-size: 16px;
        line-height: 20px;
        @include media($lg) {
            font-size: 18px;
        }
    }

    .custom-dropdown {
        top: 0;
        left: 0;
    }

    .dropdown__links {
        padding: 7px 14px;
        text-align: left;
        font-size: 16px;
        line-height: 26px;
    }

    .dropdown__link {
        padding-bottom: 7px;
        a {
            color: $hsl-color-blue-56;
            text-decoration: underline;
            &:hover {
                color: $hsl-color-blue-56;
                text-decoration: none;
            }
        }
    }

    .price-modal-text {
        margin-top: 20px;
    }

    .price-modal-buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .cs-button {
          padding: 15px 20px;
          @include media($md) {
            padding: 15px 30px;
          }
        }
    }
</style>
